// Documents list for the calendar sidebar "phone" preview.
// Copy of the workouts module's WorkoutDocumentComponent, view-only (no fetch dispatch);
// interaction is blocked by the preview overlay.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

const DocumentButton = styled('div')`
  border: 1px solid lightgray;
  border-radius: 12px;
  background: white;
  width: 200px;
  cursor: pointer;
  padding: 10px;
`;

const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  margin-bottom: 15px;
`;

const DocumentText = styled('div')`
  font-family: 'Nunito Sans';
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  font-size: 12px;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const IconTextWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 5px;
    min-width: 15px;
    margin-top: 1px;
  }
`;

const getDocumentIconByType = (docType) => {
  if (docType && docType.toLowerCase() === 'link') {
    return 'globe';
  }
  return 'file';
};

const CalendarWorkoutDocuments = ({ workoutObject }) => (
  <Container>
    {workoutObject.documents.map((document) => (
      <DocumentButton key={document.id}>
        <IconTextWrapper>
          <IcomoonReact
            iconSet={iconSet}
            size={15}
            icon={getDocumentIconByType(document?.typeDescription)}
            color='#3FBFE1'
          />
          <DocumentText>{document.name}</DocumentText>
        </IconTextWrapper>
      </DocumentButton>
    ))}
  </Container>
);

CalendarWorkoutDocuments.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarWorkoutDocuments;
